module.exports = __webpack_public_path__ + "img/gather sleeve opening.a22e9121.png";